// extracted by mini-css-extract-plugin
export default {"error":"ServerErrors_error_mtw1t","errors":"ServerErrors_errors_BGRLx","cross":"ServerErrors_cross_lVG76"};